import {
  useConfigurableList,
  useAddConfigurableListItem,
  useUpdateConfigurableListItem,
  useDeleteConfigurableListItem,
} from '@/hooks/useConfigurableLists';
import StringListEditor from '../components/StringListEditor';

export default function LineItemCategoriesSettings() {
  const { data: items = [], isLoading } = useConfigurableList('line_item_category');
  const addMutation = useAddConfigurableListItem('line_item_category');
  const updateMutation = useUpdateConfigurableListItem('line_item_category');
  const deleteMutation = useDeleteConfigurableListItem('line_item_category');

  return (
    <StringListEditor
      title="Line Item Categories"
      items={items.map((item) => ({ id: item.id, value: item.value }))}
      isLoading={isLoading}
      onAdd={(value) => addMutation.mutate(value)}
      onUpdate={(id, value) => updateMutation.mutate({ id, value })}
      onDelete={(id) => deleteMutation.mutate(id)}
      isAdding={addMutation.isPending}
      isUpdating={updateMutation.isPending}
      isDeleting={deleteMutation.isPending}
    />
  );
}
